import { PRIMARY_PHRASE } from "../categories";

export const getPrimaryPhraseLabels = (data) => {
  if (data && data.length < 1) return [];
  return [...data]
    .filter((label) => {
      return label.category === PRIMARY_PHRASE;
    })
    .sort((a, b) => (a.name > b.name ? 1 : -1));
};